import { useDialog } from "@vintecc/components";

import { ShortcutConfig, useShortcuts } from "./useShortcuts";
import { DebugModal } from "../components/DebugModal/DebugModal";
import { useState, useEffect } from "react";

export const useDebug = ({ enabled, variables }: { enabled?: boolean; variables?: Record<string, string | number | boolean> }) => {
  const [shortcuts, setShortcuts] = useState<ShortcutConfig[]>([]);

  const { open } = useDialog(DebugModal);

  useEffect(() => {
    if (!enabled) return;

    setShortcuts([
      {
        shortcut: "space+d",
        action: () => open({ variables }),
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  useShortcuts(shortcuts);

  return { variables };
};
